module.exports = __webpack_public_path__ + "static/media/bg-flora-left-desk.9290904a.svg";